import { render, staticRenderFns } from "./AufgabenComponentAufgabeDelegierenRueckmeldung.vue?vue&type=template&id=7c2477b7&scoped=true"
import script from "./AufgabenComponentAufgabeDelegierenRueckmeldung.vue?vue&type=script&lang=js"
export * from "./AufgabenComponentAufgabeDelegierenRueckmeldung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2477b7",
  null
  
)

export default component.exports